<template>
    <bottom-sheet v-model="shows" title="프로그램 참여 신청" fullscreen persistent width="1080" maxWidth="95%" needsLogin>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, loading }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <template v-if="loading">
                <v-overlay absolute color="white">
                    <v-progress-circular indeterminate size="100" width="5" color="primary" />
                </v-overlay>
            </template>
            <template v-else>
                <template v-if="step == STEPS.FINISH.value">
                    <v-sheet class="d-flex flex-column align-center">
                        <i class="icon icon-check mb-20 mb-lg-40"></i>
                        <v-sheet class="text-center mb-20 mb-lg-40">
                            <h3 class="tit mb-8 mb-lg-16">참여신청 완료</h3>
                            <p class="page-text--lg grey-6--text">"{{ program.subject }}" 프로그램에 대한 신청이 완료되었습니다.</p>
                        </v-sheet>
                        <div class="v-btn-group mt-0">
                            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="exit"><span>확인</span></v-btn>
                        </div>
                    </v-sheet>
                </template>
                <template v-else>
                    <div class="text-center mb-20 mb-lg-40">
                        <h3 class="tit">
                            <template v-if="step == STEPS.INFO.value">
                                <span> 프로그램 참여 신청 </span>
                            </template>
                            <template v-if="step == STEPS.TIME.value">
                                <span> 면접 일정 등록 </span>
                            </template>
                        </h3>
                    </div>
                    <v-sheet class="scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
                        <v-stepper v-model="step">
                            <v-stepper-items>
                                <v-stepper-content :step="STEPS.INFO.value" class="pa-0">
                                    <form-info v-model="form" v-on="{ setIsTermsValid }" @input="emit" />
                                </v-stepper-content>
                                <v-stepper-content :step="STEPS.TIME.value" class="pa-0">
                                    <form-time v-model="form" v-bind="{ program }" @input="emit" />
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-sheet>
                    <div class="v-btn-group">
                        <template v-if="step == STEPS.INFO.value">
                            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="exit">
                                <span class="grey-6--text"> 취소하기 </span>
                            </v-btn>
                            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="next">
                                <span> 다음으로 </span>
                            </v-btn>
                        </template>
                        <template v-if="step == STEPS.TIME.value">
                            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="prev">
                                <span class="grey-6--text"> 이전으로 </span>
                            </v-btn>
                            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save">
                                <span> 신청하기 </span>
                            </v-btn>
                        </template>
                    </div>
                </template>
            </template>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";
import { initExpoEmployer, initExpoProgram } from "@/assets/variables/inits";
import { getGeolocation } from "@/plugins/getGeolocation";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import FormInfo from "./form/form-info.vue";
import FormTime from "./form/form-time.vue";

const STEPS = {
    INFO: { value: "INFO", text: "기본정보" },
    TIME: { value: "TIME", text: "개인정보" },
    FINISH: { value: "FINISH", text: "신청완료" },
};

const steps = Object.values(STEPS).map((item, index) => ({ ...item, step: index + 1 }));

export default {
    components: {
        BottomSheet,
        FormInfo,
        FormTime,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        form: initExpoEmployer(),
        isTermsValid: undefined,

        shows: false,
        loading: false,

        step: steps[0].value,
        steps,
        STEPS,
    }),
    computed: {
        ...mapGetters(["_user"]),
        _program() {
            return this.program._id;
        },
        isCreate() {
            return !this.form?._id;
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { _program } = this;
                const { employers } = await api.v1.company.expo.employers.gets({
                    params: { _program },
                });
                let employer = employers?.[0];
                if (!employer) {
                    const { user } = await api.v1.me.get();
                    employer = {
                        info: {
                            name: user?.name,
                            site: user?.website,
                            phone: user?.phone?.phoneNumberFormat?.(),
                            email: user?.email,
                            postcode: user?.postcode,
                            address1: user?.address1,
                            address2: user?.address2,
                            geolocation: user?.geolocation,
                        },
                    };
                }
                this.form = initExpoEmployer(employer);

                if (this.form._id) {
                    this.$emit("input", this.form);
                }
            } finally {
                this.loading = false;
            }
        },
        async exit() {
            if (!this.form._id) {
                let keys_info = Object.keys(this.form.info);
                if (keys_info.some((key) => !!this.form.info[key])) {
                    const go = confirm("작성중인 내용이 있습니다.\n취소 시 작성중인 내용이 사라집니다.");
                    if (!go) return;
                }
            }
            this.shows = false;

            if (this.form._id) {
                this.$emit("input", this.form);
            }
        },
        async next() {
            if (!this.validate()) return;

            let index = this.steps.findIndex(({ value }) => value == this.step);
            this.step = this.steps[index + 1]?.value;
        },
        async prev() {
            let index = this.steps.findIndex(({ value }) => value == this.step);
            this.step = this.steps[index - 1]?.value;
        },
        async save() {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                let { ...form } = this.form;

                form._program = this._program;

                if (form.info.address1) {
                    form.info.geolocation = await getGeolocation(form.info.address1);
                }

                let { post, put } = api.v1.company.expo.employers;
                let { employer } = await (this.isCreate ? post : put)(form);
                this.form = initExpoEmployer(employer);
                this.next();
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        emit() {
            this.form = initExpoEmployer(this.form);
        },
        setIsTermsValid(isTermsValid) {
            this.isTermsValid = isTermsValid;
        },
        validate() {
            try {
                switch (this.step) {
                    case STEPS.INFO.value: {
                        if (!this.form.info.desc) throw new Error("구인기업 소개를 입력해주세요");
                        if (!this.form.info.body) throw new Error("구인내용을 입력해주세요");
                        if (!this.form.info.name) throw new Error("기업명을 입력해주세요");
                        if (!this.form.info.worker) throw new Error("담당자를 입력해주세요");
                        if (!this.form.info.phone) throw new Error("연락처를 입력해주세요");
                        if (!this.form.info.email) throw new Error("이메일을 입력해주세요");
                        if (!this.form.info.site) throw new Error("홈페이지를 입력해주세요");
                        if (!this.form.info.address1) throw new Error("주소를 입력해주세요");
                        if (!this.isTermsValid) throw new Error("필수약관에 동의해주세요");
                        break;
                    }
                }

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
    },
    watch: {
        _program() {
            this.init();
        },
        _user() {
            this.init();
        },
        shows(shows) {
            if (shows) this.$nextTick(this.init);
        },
    },
    mounted() {
        this.init();
    },
};
</script>
